"use client"

import * as React from "react"

import type { ResolvedStorefrontConfig, StoreConfig } from "@workspace/model"

/**
 * Client-side store-config context (US-011). Holds the config the root layout
 * fetched server-side (via `getAppSettings`) plus the resolved theme/layout and
 * active currency, so Client Components can read tenant config without re-fetching.
 */
export interface StoreConfigContextValue {
  config: StoreConfig
  resolved: ResolvedStorefrontConfig
  currency: string
}

const StoreConfigContext = React.createContext<StoreConfigContextValue | null>(
  null
)

export function StoreConfigProvider({
  value,
  children,
}: {
  value: StoreConfigContextValue
  children: React.ReactNode
}) {
  return (
    <StoreConfigContext.Provider value={value}>
      {children}
    </StoreConfigContext.Provider>
  )
}

export function useStoreConfig(): StoreConfigContextValue {
  const ctx = React.useContext(StoreConfigContext)
  if (!ctx) {
    throw new Error("useStoreConfig must be used within a StoreConfigProvider")
  }
  return ctx
}
